import { isMobile } from "common/utils/browser";
import initSlider from "common/utils/ui/slider";

import "./upsell-other-transfers.scss";

export const initUpsellScroll = parent => {
  if (isMobile()) {
    return false;
  }

  return initSlider({
    parent,
    list: ".js-upsell-transfer-list",
    grid: ".js-upsell-transfer-grid",
    arrowLeft: ".js-upsell-transfer-scroll-left",
    arrowRight: ".js-upsell-transfer-scroll-right",
    hiddenClass: "upsell-other-transfers__scroll-button--disabled"
  });
};

export default () => {
  initUpsellScroll();
};
